import { ReactNode } from "react";

import { BrowserFrame } from "./BrowserFrame";
import { Sidebar } from "./Sidebar";
import { DashboardHeader } from "./DashboardHeader";

interface DashboardShellProps {
    accent: string;

    sidebar: string[];

    title: string;

    subtitle: string;

    children: ReactNode;
}

export function DashboardShell({
    accent,
    sidebar,
    title,
    subtitle,
    children,
}: DashboardShellProps) {
    return (
        <BrowserFrame accent={accent} className="w-full">
            <div className="flex min-h-[620px]">
                <Sidebar
                    accent={accent}
                    items={sidebar}
                />

                <div className="flex min-w-0 flex-1 flex-col">
                    <DashboardHeader
                        title={title}
                        subtitle={subtitle}
                    />

                    <div className="flex-1 overflow-y-auto bg-background p-4">
                        {children}
                    </div>
                </div>
            </div>
        </BrowserFrame>
    );
}